module.exports = __webpack_public_path__ + "static/media/attendance-bgm.bcef3b60.mp3";